import { subDays, subWeeks } from 'date-fns';
import { makeEntityScaffold } from '@classpass/saga-tools';

import { transformV2ClientResponse } from 'helpers/core';

import URLS from 'constants/urls';
import { YOUR_INSIGHTS_MODULE_TYPES } from 'features/Stats/Stats.constants';

const handler = ({ httpClient }, url, range) => {
  const today = new Date();
  // Most insights modules report through T-1; data does not include the current calendar day.
  // iOS app impressions lag the standard pipeline; T-3 aligns end_date with available data.
  const endDate = url.includes(YOUR_INSIGHTS_MODULE_TYPES.IOS_APP_IMPRESSIONS) ? subDays(today, 3) : subDays(today, 1);
  const startDate = subWeeks(endDate, range);

  return httpClient.get(URLS.stats.insightsModule(url, startDate, endDate)).then(transformV2ClientResponse);
};

export default makeEntityScaffold('SAGA.API.STATS_INSIGHTS_MODULE', handler, { defaultKey: [2, 1] });
